// import Footer from "../footer/Footer";
import { Outlet } from "react-router-dom";
import LoadingSpinner from "../../../Loading/LoadingSpinner";
import HeaderCargo from "../../cargo/header/Header";
import Toast from "../../../Modals/toast/Toast";
import HeaderDriver from "../../driver/header/DriverHeader";

export default function DriverLayout({ children }) {
  return (
    <>
    <div className="w-screen">
    <Toast></Toast>

      <HeaderDriver/>
      <LoadingSpinner></LoadingSpinner>
      <Outlet />
      {/* <Footer /> */}
      </div>
 
    </>
  );
}